export const FormSectionsFREDDIE = [
	'overview',
	'pdfreview',
	'photoreview'
];

export const UiSectionsFREDDIE = FormSectionsFREDDIE;

export enum RulesBaseFREDDIE {
	OVERVIEW = 1000,
	REVISIONS = 1000,
	PDFREVIEW = 2000,
	PHOTOREVIEW = 3000,
}
